import { MotorsportsCalendarPageProps, MotorsportsSessionRowSession } from '@sky-it-livedata/livedata-sports-design-system';

import { getCalendarSeasonByGPCalendar } from '../../../utils/calendar';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { isValidCompetitionCalendar } from './typeguards';
import { CompetitionCalendarQuery } from '../types';
import { CreateGpCalendarWidgetInputSchema, GpCalendarGpInfo, GpCalendarItem, GpCalendarItemSessions, GpCalendarWidget } from 'cdk/graphql';
import { buildGPSessionsByDate, filterSessions, getGPEndDate, getGPStartDate } from '../../../utils/session';
import { RaceSessionStatus, RaceSessionType } from '../../../types/race-session';


const transformer = (obj: CompetitionCalendarQuery): MotorsportsCalendarPageProps => {
  if (isValidCompetitionCalendar(obj)) {
    console.log('CompetitionCalendarQuery is valid:', obj);
    
    CreateGpCalendarWidgetInputSchema().parse(obj.data.getGpCalendarWidget, {reportInput: true});
    const gpCalendarWidget: GpCalendarWidget = obj.data.getGpCalendarWidget;

    const motorsportsCalendarPageData =
      (gpCalendarWidget.items ?? [])
        .filter((item): item is GpCalendarItem => Boolean(item && (item as GpCalendarItem).gpInfo))
        .map((item) => {
          const { gpInfo, sessions } = item;
          const {
            circuitUrl,
            customGpName,
            flagUrl,
            gpPageUrl,
            isCurrent,
            isExclusive: isExclusiveLive,
            laps,
            lengthKm,
          } = gpInfo as GpCalendarGpInfo;

          const transformedSessions = (sessions as GpCalendarItemSessions).items?.map((sessionObj) => {
            const session = sessionObj;
            const { sessionLabel: sessionName, sessionStatus, sessionInfo, sessionResultUrl } = session || {};
            
            return {
              sessionName: sessionName as RaceSessionType,
              sessionStatus: sessionStatus as RaceSessionStatus,
              sessionResultUrl,
              sessionDate: sessionInfo?.startDateTime as string| undefined,
            };
          }).filter(filterSessions) as MotorsportsSessionRowSession[]; // Filter STARTING_GRID and OTHER SESSIONS...

          const gpSessions = buildGPSessionsByDate(transformedSessions) || []; // Sort SESSION by DATE/TIME

          return {
            circuitUrl: circuitUrl as string,
            dateEnd: getGPEndDate(gpSessions),
            dateStart: getGPStartDate(gpSessions) || undefined,
            distance: lengthKm ?? '-',
            flagUrl: flagUrl as string,
            gpPageUrl: gpPageUrl as string,
            isCurrent: isCurrent as boolean,
            isExclusiveLive: isExclusiveLive as boolean,
            laps: laps ?? '-',
            name: customGpName as string,
            sessions: gpSessions,
          };
        });

    const season = getCalendarSeasonByGPCalendar(motorsportsCalendarPageData);

    return {
      motorsportsCalendarPageData,
      season,
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in CompetitionCalendarQuery object',
      data: obj
    });
  }
};

export default transformer;
